import { Bold1 } from './Bolden';
import { General } from './General';
import { TextExtraLarge } from './TextExtraLarge';
import { TextLarge } from './TextLarge';
import { TextMedium } from './TextMedium';
import { TextRegular } from './TextRegular';
import { TextSmall } from './TextSmall';
import { Title } from './Title';

export const Typography = {
  Title,
  General,
  Bold1,
  TextSmall,
  TextRegular,
  TextMedium,
  TextLarge,
  TextExtraLarge,
};

export { type TextProps } from './TextBase';
